// extracted by mini-css-extract-plugin
export var container = "fv_f";
export var contentLeft = "fv_fg";
export var contentRight = "fv_c1";
export var divider = "fv_jg";
export var footerGridBottom = "fv_l6";
export var termsContainer = "fv_l7";